export default __webpack_public_path__ + "static/media/cn.ab2a9298.png";